import { apiFetch } from "../../lib/utils"; // Import apiFetch for API calls

const PdfEndPoint = "/Pdf"; // Define the endpoint for the Pdf API

// Function to fetch PDF list using only sendingId
const GetInvoiceList = async (sendingId: number): Promise<string[]> => {
    try {
        const response = await apiFetch(`${PdfEndPoint}/api/list/${sendingId}`, "GET");
        if (!response.ok) {
            throw new Error(`Failed to fetch invoice list: ${response.statusText}`);
        }
        const invoiceList = await response.json(); // Return the list of PDF files
        return invoiceList;
    } catch (error) {
        console.error('Error fetching invoice list:', error);
        return [];
    }
};

// Function to fetch a specific PDF file using only sendingId and fileName
const GetInvoicePdf = async (sendingId: number, fileName: string): Promise<Blob> => {
    try {
        const response = await apiFetch(`${PdfEndPoint}/api/fetch/${sendingId}/${fileName}`, "GET");
        if (!response.ok) {
            throw new Error(`Failed to fetch PDF file: ${response.statusText}`);
        }
        const pdfBlob = await response.blob(); // Return the file as a blob
        return pdfBlob;
    } catch (error) {
        console.error('Error fetching PDF file:', error);
        throw error;
    }
};

// Export the PDF API functions
export {
    GetInvoiceList,
    GetInvoicePdf
};
